<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        <ng-container [formGroup]="product">
          <ng-container formGroupName="parameters">
            <div class="row">
              <div class="col col-md-8">
                <title
                  [style]="{
                    fontSize: '16px',
                    color: '#2E557A',
                    fontWeight: '500',
                  }"
                  direction="left"
                >
                  Souhaitez-vous sécuriser la totalité des supports en unités de
                  compte éligibles et présents sur mon contrat ou à venir ?
                </title>
              </div>
              <div class="col col-md-4">
                <pr-input-radio
                  formControlName="avOptionSecurisationPlusValuesTotaliteSupport"
                  direction="column"
                  [isDefault]="false"
                  [toggle]="true"
                  [columns]="3"
                >
                </pr-input-radio>
              </div>
            </div>
            <ng-container formArrayName="avOptionSecurisationPlusValuesLimits">
              @for (
                repartition of controls;
                track repartition;
                let index = $index
              ) {
                <ng-container [formGroup]="repartition">
                  <div class="row">
                    <div class="col col-md-10">
                      <!-- test -->
                      <div>
                        <div class="repartition">
                          <div class="repartition__label">
                            <div class="repartition__label__title">
                              {{
                                product
                                  ?.get('parameters')
                                  ?.get(
                                    'avOptionSecurisationPlusValuesTotaliteSupport'
                                  )?.value === false
                                  ? repartition?.get('name')?.value
                                  : 'tous'
                              }}
                            </div>
                            <div class="repartition__label__subtitle">
                              {{
                                product
                                  ?.get('parameters')
                                  ?.get(
                                    'avOptionSecurisationPlusValuesTotaliteSupport'
                                  )?.value === false
                                  ? repartition.get('isin')?.value
                                  : ''
                              }}
                            </div>
                          </div>
                          <div
                            class="repartition__input"
                            [ngClass]="{
                              'is-invalid':
                                derrors && repartition?.get('limit')?.errors,
                            }"
                          >
                            <mat-select
                              formControlName="limit"
                              placeholder="Choix du seuil"
                            >
                              @for (option of limitOtions; track option) {
                                <mat-option [value]="option.value">
                                  {{ option.label }}
                                </mat-option>
                              }
                            </mat-select>
                          </div>
                          <div style="width: 176px; height: 44px">
                            @if (repartition?.get('limit')?.value == 'CUSTOM') {
                              <div
                                class="repartition__input"
                                [ngClass]="{
                                  'is-invalid':
                                    derrors &&
                                    repartition?.get('limitCustom')?.errors,
                                }"
                              >
                                <input
                                  class="repartition__input__custom"
                                  formControlName="limitCustom"
                                  type="number"
                                  min="0"
                                  max="100"
                                  fraction="2"
                                />
                                <i>%</i>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- remove  -->
                    @if (
                      product
                        ?.get('parameters')
                        ?.get('avOptionSecurisationPlusValuesTotaliteSupport')
                        ?.value === false
                    ) {
                      <div class="col col-md-2">
                        @if (avOptionSecurisationPlusValuesLimits.length > 1) {
                          <pr-button-confirm
                            class="confirm"
                            display="danger"
                            clazz="pr-toolbar-button last"
                            icon="delete"
                            title="Suppression"
                            comment="Toute suppression est définitve, les données seront perdues."
                            labelConfirm="Supprimer"
                            labelCancel="Annuler"
                            (onConfirm)="deleteFields(index)"
                          >
                            Êtes-vous sûr(e) de vouloir supprimer
                            <em
                              >“{{
                                avOptionSecurisationPlusValuesLimits?.controls[
                                  index
                                ]?.value
                              }}”</em
                            >
                          </pr-button-confirm>
                        }
                      </div>
                    }
                  </div>
                  <!-- test -->
                </ng-container>
                <ng-template> </ng-template>
              }
            </ng-container>
          </ng-container>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
